import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  setAuthCookie,
  getAuthCookie,
  removeAuthCookie,
} from "../../utils/cookie";
const REACT_APP_API_URL =
  process.env.REACT_APP_API_URL || "https://api.fetanmarket.com";
console.log("REACT_APP_API_URL: ", REACT_APP_API_URL);

export const registerUser = createAsyncThunk(
  "auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${REACT_APP_API_URL}/auth/register`, {
        email: userData.email,
        username: userData.username,
        role_name: userData.role_name,
        phone: userData.phone,
        password: userData.password,
        name: userData.name,
      });
      return {
        data: response.data,
        status: response.status,
        error: response.error,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed",
      );
    }
  },
);

export const loginUser = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/login`,
        {
          username: credentials.username,
          password: credentials.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  },
);

export const fetchProtectedData = createAsyncThunk(
  "auth/fetchProtectedData",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.get(`${REACT_APP_API_URL}/protected/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data.data.user);
      return {
        user: response.data.data.user,
        token,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const verifyPhone = createAsyncThunk(
  "auth/verifyPhone",
  async ({ code, phone }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/verify-phone`,
        { code, phone },
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "OTP failed" });
    }
  },
);
export const verifyPhoneOtp = createAsyncThunk(
  "auth/verifyPhone",
  async ({ otp, phone }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/verify-phone-otp`,
        { otp, phone },
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "OTP failed" });
    }
  },
);

export const verifyEmail = createAsyncThunk(
  "auth/verify-emial",
  async ({ otp, email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/verify-email`,
        { otp, email },
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "OTP failed" });
    }
  },
);

export const loginWithNumber = createAsyncThunk(
  "auth/loginWithNumber",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/login-with-phone`,
        {
          phone: credentials.phone_number,
        },
        {
          headers: {
            "Content-Type": "application/json", // ✅ Send as JSON
          },
        },
      );

      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Login failed" },
      );
    }
  },
);

export const loginverify = createAsyncThunk(
  "auth/loginverify",
  async ({ otp, phone_number, role_name }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/verify-otp`,
        { otp, phone_number, role_name },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "OTP verification failed" },
      );
    }
  },
);

export const forgotPasword = createAsyncThunk(
  "auth/forgot-password",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/forgot-password`,
        { email }, // send JSON instead of URLSearchParams
        {
          headers: {
            "Content-Type": "application/json", // JSON header
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Forgot Password failed" },
      );
    }
  },
);

export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async ({ email, otp, password, confirm_password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/reset-password`,
        {
          email,
          otp,
          password,
          confirm_password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Reset Password failed" },
      );
    }
  },
);

export const resendOTP = createAsyncThunk(
  "auth/resend-otp",
  async ({ email, phone }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/auth/resend-otp`,
        {
          email,
          phone,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "resend OTP  failed" },
      );
    }
  },
);
export const logoutUser = () => {
  return {
    type: "auth/logout",
  };
};

export const logout = createAsyncThunk("auth/logout", () => {
  // No API call needed, we'll handle everything in the reducer
  return true;
});

const initialState = {
  user: null,
  loading: false,
  error: null,
  success: false,
  token: null,
  isAuthenticated: false,
  protectedData: null,
  authChecked: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.error = null;
      state.success = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.success = true;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.isAuthenticated = false;
        state.error = action.payload;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.token = action.payload.access_token;
        state.isAuthenticated = true;
        state.success = true;
        setAuthCookie(action.payload.access_token);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.isAuthenticated = false;
      })
      .addCase(loginWithNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginWithNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.success = true;
      })
      .addCase(loginWithNumber.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.isAuthenticated = false;
        state.error = action.payload;
      })

      .addCase(verifyPhoneOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.data.access_token;
        state.isAuthenticated = true;
        state.success = true;
        setAuthCookie(action.payload.data.access_token);
      })
      .addCase(verifyPhoneOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.isAuthenticated = false;
      })
      .addCase(fetchProtectedData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProtectedData.fulfilled, (state, action) => {
        // console.log(action.payload);
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        state.protectedData = action.payload.user;
        state.authChecked = true;
      })
      .addCase(fetchProtectedData.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.authChecked = true;
        state.error = action.payload?.message;
      })

      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.profile = null;
        state.isAuthenticated = false;
        removeAuthCookie();
      })
      .addCase(loginverify.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.access_token;
        state.isAuthenticated = true;
        state.success = true;
        setAuthCookie(action.payload.access_token);
      })
      .addCase(loginverify.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "OTP verification failed";
        state.success = false;
        state.isAuthenticated = false;
      });
  },
});

export const { resetAuthState, clearError } = authSlice.actions;
export default authSlice.reducer;
